module.exports = __webpack_public_path__ + "img/border2.584f8631.png";